// tslint:disable
/**
 * Robotic Platform Pattern Generation API
 * WebSocket API contract for generating palletization strategy templates and layer layouts.  This module is exposed through the Robotic Platform WebSocket dispatcher (not a standalone REST API). The OpenAPI path below documents the JSON request/response message payload for the `generatePatternPlan` handler.  Transport notes: - Connect to the WebSocket server and send a JSON object with top-level `type: generatePatternPlan` - Receive one JSON response frame for the request (success or handler-level error) - Validation and internal handler errors are encoded in the JSON response body with `status: error` - No module-level authentication or rate limiting is implemented in this repository 
 *
 * The version of the OpenAPI document: 1.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Optional symmetry preference metadata from the caller. The simplified response always returns all available layer-B symmetry variants for each strategy. This field is currently accepted for compatibility and does not filter the returned strategy templates. Unknown fields are ignored by the backend. 
 * @export
 * @interface SymmetryOptions
 */
export interface SymmetryOptions {
    [key: string]: object | any;

    /**
     * Symmetry type (parsed case-insensitively by backend, but not used to filter the simplified response).
     * @type {string}
     * @memberof SymmetryOptions
     */
    type?: SymmetryOptionsTypeEnum;
    /**
     * Symmetry origin X (same units as dimensions). Must be finite if provided. Accepted for compatibility with older request shapes. 
     * @type {number}
     * @memberof SymmetryOptions
     */
    origin_x?: number;
    /**
     * Symmetry origin Y (same units as dimensions). Must be finite if provided. Accepted for compatibility with older request shapes. 
     * @type {number}
     * @memberof SymmetryOptions
     */
    origin_y?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum SymmetryOptionsTypeEnum {
    NONE = 'none',
    MIRROR_X = 'mirror_x',
    MIRROR_Y = 'mirror_y',
    MIRROR_XY = 'mirror_xy',
    ROTATE_180 = 'rotate_180'
}



